import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class VisitorService {

    static getVisitor() {

        let api = `${API_BASE_URL}${API_PATHS.getVisitor}`;

        return axiosInstance.get(api,);
    }
    static addVisitor() {

        let api = `${API_BASE_URL}${API_PATHS.addVisitor}`;

        return axiosInstance.post(api,);
    }


}

export default VisitorService;
